import getNextTodoId from './getNextTodoId';
import getPreviousTodoId from './getPreviousTodoId';
import getSelectedFolderView from './getSelectedFolderView';

export default function(todoid: string, fromActiveList: boolean): string {
    const folderView = getSelectedFolderView();
    const taskIds = fromActiveList ? folderView.activeTaskIds : folderView.recentlyCompletedTaskIds;

    let nextFocusId = getNextTodoId(todoid, taskIds);
    if (!nextFocusId) {
        nextFocusId = getPreviousTodoId(todoid, taskIds);
    }
    return nextFocusId;
}
